import styled from 'styled-components';

export const LogoImageWrapper = styled.div((props) => ({
  width: '100%',
  margin: '0 0 19px',
  padding: '0 0 19px',
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderStyle: "solid",
  borderColor: props.theme.newPalette.background.gray[300],
  borderBottomWidth: 2,

  '& img': {
    width: '100%',
  },

  [`@media${props.theme.devices.laptop}`]: {
    margin: '0 0 16px',
    width: '135px',
  },
}));
